import { cn } from "@/lib/utils"
import { Check } from "lucide-react"

const steps = [
  { label: "Identify Parcel", step: 1 },
  { label: "Select Package", step: 2 },
  { label: "Processing", step: 3 },
  { label: "Results", step: 4 },
]

export function StepIndicator({ currentStep }: { currentStep: number }) {
  return (
    <div className="mx-auto w-full max-w-2xl px-4">
      <nav aria-label="Progress steps" className="flex items-center justify-between">
        {steps.map(({ label, step }, index) => {
          const isCompleted = currentStep > step
          const isCurrent = currentStep === step

          return (
            <div key={step} className="flex flex-1 items-center">
              <div className="flex flex-col items-center gap-1.5">
                <div
                  className={cn(
                    "flex size-8 items-center justify-center rounded-full border-2 text-xs font-semibold transition-colors",
                    isCompleted && "border-primary bg-primary text-primary-foreground",
                    isCurrent && "border-primary bg-background text-primary",
                    !isCompleted && !isCurrent && "border-border bg-background text-muted-foreground"
                  )}
                  aria-current={isCurrent ? "step" : undefined}
                >
                  {isCompleted ? <Check className="size-4" /> : step}
                </div>
                <span
                  className={cn(
                    "text-[10px] font-medium leading-tight sm:text-xs",
                    isCurrent ? "text-primary" : "text-muted-foreground"
                  )}
                >
                  {label}
                </span>
              </div>

              {index < steps.length - 1 && (
                <div
                  className={cn(
                    "mx-2 h-0.5 flex-1 rounded-full",
                    isCompleted ? "bg-primary" : "bg-border"
                  )}
                  aria-hidden="true"
                />
              )}
            </div>
          )
        })}
      </nav>
    </div>
  )
}
